import CategoryContainer from "./CategoryContainer";

export default CategoryContainer;
